/**
 * @Date:   2018-02-11T10:47:44+08:00
 * @Last modified time: 2018-02-11T10:49:04+08:00
 */
import _util from '../../utils/';

const dailyReportService = {
	initDailyReport(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Post',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	saveDailyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	fetchDailyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateDailyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	fetchDailyReportDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Details',
			params: gets,
			success: resolve,
			error: reject
		})		
	},
	multiDeleteDailyReport(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})			
	},
	submitDailyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})		
	},

	
	fetchLeaderDailyReportList(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/GetForLeader',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	fetchHrDailyReportList(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReport/GetForHr',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	replyDailyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportReply/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	},
	multiNotify(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportNotification/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	}


}

export default dailyReportService;



// WEBPACK FOOTER //
// ./src/services/DailyReport/daily-report-service.js